import Accordion from 'accordion-js';
import { initLightboxJS } from 'lightbox.js-react';
import Iconify from '@iconify/iconify';
import startTrackingDataStorage from './store-tracking-data';

import './base/navbar.responsive';
import { checkIsMobileBrowser } from './widget/utils/checkIsMobileBrowser';
import {
  blockScrollDesktop,
  blockScrollMobile,
  restoreScrollDesktop,
  restoreScrollMobile,
} from './widget/utils/blockScroll';

const ready = () => {
  import('./swipers').then((module) => {
    module.initAllSwipers();
  });
  import('./tabs').then((module) => {
    module.initAllTabs();
  });
  import('./map').then((module) => {
    module.async_initAllMaps();
  });

  initFooterDropdownsListener();
  initModalSlider();
  initBookingFormButtonListener();
  initListingDescription();
  initAccordions();
  initAnchorScroll();
  //TODO: find a better place for the key
  initLightboxJS('017B-D39B-1FB4-CBEC', 'team');
};

startTrackingDataStorage();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}

function initListingDescription() {
  const $toggleDescription = document.querySelector(
    '[data-toggle-description]'
  );
  const $target = document.querySelector('[data-toggle-description-target]');
  const $description = document.querySelector('[data-croppable]');

  if (!$toggleDescription || !$description || !$target) {
    return;
  }

  const textOpen = $toggleDescription.getAttribute('data-text-open');
  const textClose = $toggleDescription.getAttribute('data-text-close');
  let isOpen = false;

  $toggleDescription.addEventListener('click', () => {
    $description.classList.toggle('open');
    isOpen = !isOpen;
    $target.innerText = isOpen ? textOpen : textClose;

    if (!isOpen) {
      const descriptionDiv = document.querySelector(
        'div.product__description__inner'
      );
      descriptionDiv
        ? descriptionDiv.scrollIntoView({ behavior: 'smooth' })
        : null;
    }
  });
}

function initAnchorScroll() {
  const $anchorLinks = document.querySelectorAll('[data-anchor-scroll]');

  if (!$anchorLinks || !$anchorLinks.length) {
    return;
  }

  $anchorLinks.forEach(($link) => {
    $link.addEventListener('click', (e) => {
      const href = $link.getAttribute('href');

      // Only handle hash links
      if (href && href.startsWith('#')) {
        e.preventDefault();

        const targetId = href.substring(1);
        const $target = document.getElementById(targetId);

        if ($target) {
          $target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
}

function initFooterDropdownsListener() {
  const $dropdowns = document.querySelectorAll('.footer-dropd');
  if ($dropdowns && !!$dropdowns.length) {
    for (let i = 0; i < $dropdowns.length; i++) {
      const $dropdownTitle = $dropdowns[i].querySelector(
        '.footer-dropd__title'
      );
      const $dropdownChildren = $dropdowns[i].querySelector(
        '.footer-dropd__children'
      );
      $dropdownTitle.addEventListener('click', () => {
        [$dropdownTitle, $dropdownChildren].forEach(
          ($item) => $item && $item.classList.toggle('open')
        );
      });
    }
  }
}

function initModalSlider() {
  const $modalOverlaySlider = document.querySelector(
    '[data-modal="overlay-slider"]'
  );
  const $btnOpenOverlay = document.querySelector(
    '[data-modal="overlay-opener"]'
  );
  const $btnCloseOverlay = document.querySelector(
    '[data-modal="close-overlay"]'
  );
  const $fixedFooter = document.querySelector('[data-fixed-footer]');

  if ($modalOverlaySlider && $btnOpenOverlay && $btnCloseOverlay) {
    $btnOpenOverlay.addEventListener('click', () => {
      if (checkIsMobileBrowser()) {
        blockScrollMobile();
      } else {
        blockScrollDesktop();
      }
      $modalOverlaySlider.classList.add('open');
      $fixedFooter.classList.add('hidden');
    });
    $btnCloseOverlay.addEventListener('click', () => {
      if (checkIsMobileBrowser()) {
        restoreScrollMobile();
      } else {
        window.setTimeout(() => restoreScrollDesktop(), 200);
      }
      $modalOverlaySlider.classList.toggle('open');
      $fixedFooter.classList.remove('hidden');
    });
    $modalOverlaySlider.addEventListener('click', (e) => {
      if (e.target === $modalOverlaySlider) {
        if (checkIsMobileBrowser()) {
          restoreScrollMobile();
        } else {
          window.setTimeout(() => restoreScrollDesktop(), 200);
        }
        $modalOverlaySlider.classList.toggle('open');
        $fixedFooter.classList.remove('hidden');
      }
    });
  }
}

function initBookingFormButtonListener() {
  const $BookingFormOpener = document.querySelector(
    '[data-overlay-button="booking-form"]'
  );
  const $BookingFormContainer = document.querySelector(
    '[data-overlay-widget="booking-form"]'
  );
  if ($BookingFormOpener && $BookingFormContainer) {
    $BookingFormOpener.addEventListener('click', (e) => {
      e.preventDefault();
      $BookingFormContainer.classList.add('open');
      if (checkIsMobileBrowser()) {
        blockScrollMobile();
      } else {
        blockScrollDesktop();
      }
    });
  }
}

function initAccordions() {
  const $accordions = Array.from(
    document.querySelectorAll('.accordion-container')
  );

  if (!$accordions) {
    return;
  }

  new Accordion($accordions, {
    showMultiple: true,
    duration: 200,
  });
}

// Set the viewport height in CSS variables
document
  .querySelector(':root')
  .style.setProperty('--vh', window.innerHeight / 100 + 'px');
window.addEventListener('resize', () => {
  document
    .querySelector(':root')
    .style.setProperty('--vh', window.innerHeight / 100 + 'px');
});

export function getFlagCodeFromLanguage(lang) {
  switch (lang) {
    case 'en':
      return 'gb-ukm';
    case 'ar':
      return 'sa';
    case 'cs':
      return 'cz';
    case 'sr':
      return 'rs';
    case 'uk':
      return 'ua';
    default:
      return lang;
  }
}
